// extracted by mini-css-extract-plugin
export default {"wrapper":"UsersList_wrapper__PqQ1h","container":"UsersList_container__xz78Q"};